import React from 'react';
import { Select } from 'antd';
import './public-component.less';

export enum ProjectStageStatus {
    waiting = 0,
    running = 1,
    completed = 2,
}

const options = [
    { value: ProjectStageStatus.waiting, label: '待开始' },
    { value: ProjectStageStatus.running, label: '进行中' },
    { value: ProjectStageStatus.completed, label: '完成' },
];

interface ProjectStageStatusSelectProps {
    value?: number;
    onChange?: (value: number) => void;
    placeholder?: string;
}

export const getProjectStageStatusText = (value: number) => {
    const found = options.find(item => item.value === value);
    return found ? found.label : '其他';
};

const ProjectStageStatusSelect: React.FC<ProjectStageStatusSelectProps> = ({ value, onChange, placeholder }) => {
    return (
        <Select className="select-stage_status" value={value} onChange={onChange} placeholder={placeholder || '状态'}>
            {options.map(option => (
                <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
            ))}
        </Select>
    );
};

export default ProjectStageStatusSelect;
